export default function () {
  return {
    parametros:null
  };
}
